<div>

    <!-- backend validation message -->
    <span [ngClass]="value ? 'select-error-value form-error-icon' : 'select-error form-error-icon'"
        *ngIf="getNgControlErrors()?.length" [ngbTooltip]="getNgControlErrors()?.length ? errorTooltip : null" #t="ngbTooltip"
        triggers="manual" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" tooltipClass="apc-tooltip-top"
        placement="top"  triggers="hover">
        <img src="assets/ico/error-solid.svg" alt="error">
    </span>
    <ng-template #errorTooltip>
        <span *ngFor="let error of getNgControlErrors()">
            {{error.message}} <br />
        </span>
    </ng-template>
    <!-- if view mode instead of select show text type su value can be copy pasted -->
    <input *ngIf='currentType == "text"' #input class="form-control select-text-placeholder" type="text" [value]="renderValue" [readonly]="true"
        (mouseenter)="handleSelectInputEdit()" (mouseleave)="setSelectType()" />

    <ng-select *ngIf="!isObject && currentType === 'select'" #select [(ngModel)]="value"
        [ngModelOptions]="{standalone: true}" [disabled]="disabled" (input)="onChange()" (change)="onChange()"
        (blur)="onTouchedFn()" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" (open)="emitSelect()"
        [placeholder]="placeholder" [loading]="loading" [items]="items" [bindLabel]="optionName"
        [attr.bindValue]="!isObject ? optionValue: null" [bindValue]="optionValue" (mouseenter)="handleSelectInputEdit()"
        (mouseleave)="setSelectType()">
        <ng-template ng-option-tmp let-option="item">
            <div class="ng-option-title">
                {{option}}</div>
        </ng-template>
    </ng-select>
    <ng-select *ngIf="isObject && currentType === 'select'" #select [(ngModel)]="value" [ngModelOptions]="{standalone: true}"
        [disabled]="disabled" (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()"
        (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" (open)="emitSelect()" [placeholder]="placeholder"
        [loading]="loading" [items]="items" [bindLabel]="optionName" (mouseenter)="handleSelectInputEdit()"
        (mouseleave)="setSelectType()" [class.autogeneratedSelect]="autogenerated">
        <ng-template ng-option-tmp let-option="item">
                <div *ngIf="activeDescToltip;else noTooltip"  [ngClass]="optionDescription && optionDescription.length > 0 ? 'font-weight-medium-bold' : ''" 
                    (mouseover)="this.showTooltip(option)"
                    (mouseout)="this.hideTooltip()"
                    (mousedown)="this.hideTooltip()" class="nameType">
                    <span>{{option[optionName]}}</span>
                </div>
                <ng-template #noTooltip>
                    <div class="ng-option-title"
                        [ngClass]="optionDescription && optionDescription.length > 0 ? 'font-weight-medium-bold' : ''">
                        {{option[optionName]}}
                    </div>
                    <div *ngIf="optionDescription && optionDescription.length > 0">
                        <div *ngFor="let optionDesc of optionDescription" class="ng-select-option-description ml-1">
                            <span *ngIf="option[optionDesc] !== null"><span><span *ngIf="!hideDescTitle">{{'columnName.' + optionDesc | translate}}: </span><em>{{option[optionDesc]}}</em></span></span>
                        </div>
                    </div>  
                </ng-template>                       
        </ng-template>       
    </ng-select>
    <div *ngIf="activeDescToltip"  class="descTooltip" #descriptionTooltip>
    </div>
    
</div>